import React from "react";
import Button from "@edaz/edazkit/Button";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { CheckArray } from "../../../controls/checkArray";
import UserIdentityProvidersViewModel from "../../../viewModels/users/users/userIdentityProvidersViewModel";

const UserIdentityProvidersView: ViewComponent<UserIdentityProvidersViewModel> = observer(({ vm }) => (
  <LoaderOverlay loading={vm.busyWatcher.isBusy}>
    <Form onSubmit={preventDefault(vm.onSubmit)}>
      <h4>{vm.translate("externalProvider")}</h4>
      <Form.Row>
        <Form.Group as={Col} md={6}>
          <Form.Row>
            {vm.externalIdentityProviderOptions.map(provider => (
              <Col sm="auto" key={provider.id}>
                <CheckArray
                  custom
                  key={provider.id}
                  target={vm}
                  disabled={!vm.allowWrite}
                  property="allowedProviders"
                  id={provider.id.toString()}
                  label={provider.label}
                />
              </Col>
            ))}
          </Form.Row>
        </Form.Group>
      </Form.Row>
      {vm.allowWrite && (
        <Button size="sm" type="submit" variant="primary">
          {vm.translate("update")}
        </Button>
      )}
    </Form>
  </LoaderOverlay>
));

registerView(UserIdentityProvidersView, UserIdentityProvidersViewModel);
